import React from "react";
import StateHandler from "../../components/StateHandler/StateHandler";
import {HttpStatusCode} from "axios";
import useGlobalState from "../../context/GlobalState";

function Unauthorized() {
    const { isLogged } = useGlobalState();

    return (
        isLogged !== undefined ? (
            <StateHandler
                title="Unauthorized"
                subTitle="You are not authorized to view this page."
                links={
                    [
                        {
                            link: "/emprendedores/admin/login",
                            label: "Login"
                        },
                    ]
                }
                showFcitecLink
                statusCode={HttpStatusCode.Unauthorized}
            />
        ): null
    );
}

export default Unauthorized;